import { render, staticRenderFns } from "./ShortAnswerRenderer.vue?vue&type=template&id=bb50e862&scoped=true"
import script from "./ShortAnswerRenderer.vue?vue&type=script&lang=js"
export * from "./ShortAnswerRenderer.vue?vue&type=script&lang=js"
import style0 from "../styles/base.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ShortAnswerRenderer.vue?vue&type=style&index=1&id=bb50e862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.8_vue-t_oz4jpprlle4dra2pgsz5us5kba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb50e862",
  null
  
)

export default component.exports